import React from 'react';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Team Lineups Condensed CTA.
 *
 * @returns The Team Lineups Condensed CTA skeleton loader.
 */
export const TLCondensedCtaSkeleton = () => (
    <>
        <div className="u-hide-until-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups-condensed-embeddable__cta">
                <div className="team-lineups-condensed-embeddable__cta-button">
                    <SkeletonLoader width={150} height={40} />
                </div>
            </div>
        </div>
        <div className="u-hide-from-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups-condensed-embeddable__cta">
                <div className="team-lineups-condensed-embeddable__cta-button">
                    <SkeletonLoader width={150} height={40} />
                </div>
            </div>
        </div>
    </>
);
